import { api } from "../utils/axios";
import { toApiError } from "./reservations.apis";

export const createUserReservations = async (
  restaurantId: string,
  body: {
    phone: string;
    partySize: number;
    startTime: string;
    endTime: string;
    occasion?: string;
    specialRequest?: string;
    acceptUpdates?: boolean;
    source: "gemio_app";
  },
): Promise<{ success: true, _id: string, reservationId: string }> => {
  try {
    const response = await api.post(`/api/reservations/public/${restaurantId}`, body);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Failed to create reservation.");
  }
};